module.exports = __webpack_public_path__ + "static/img/zhihu.2454c95a.png";